import { Empty, Flex, HitCounter, Loading } from '@/components';
import { useWorkflowStackSiderView } from '@/features/workflow/hooks/stack-sider-view';
import { useWorkflowList } from '@/features/workflow/hooks/workflow';
import { ITEM_SPLITTER, dateFormat } from '@/utils';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import invariant from 'tiny-invariant';
import { WorkflowCard } from './WorkflowCard';

export const WorkflowSiderList: FC = () => {
  const { t } = useTranslation();

  const stackSiderView = useWorkflowStackSiderView();

  const siderConfig = stackSiderView.lastItem?.config;

  invariant(siderConfig?.viewType === 'workflow-list', t('unreachable-code'));

  const workflowList = useWorkflowList({
    objectId: siderConfig.target.id,
  });

  if (workflowList.isPending) {
    return <Loading />;
  }

  if (!workflowList.data?.results.length) {
    return <Empty description={t('no-workflow-data')} />;
  }

  return (
    <Flex vertical gap={12}>
      <HitCounter count={workflowList.data.count} label={t('relevant')} />
      {workflowList.data?.results.map((workflow) => (
        <WorkflowCard
          key={workflow.id}
          id={workflow.id}
          title={workflow.title}
          isActionRequired={workflow?.actionRequired ?? false}
          status={workflow?.status}
          deadline={
            workflow.deadline
              ? dateFormat({
                  datetime: workflow.deadline,
                })
              : null
          }
          createdDate={dateFormat({
            datetime: workflow.createdAt,
          })}
          assigneeAttributes={workflow.assignees.map((assignee) => ({
            iconUrl: assignee.iconDataUrl,
            organizationName: assignee.organizations
              ?.map((d) => d.name)
              .join(ITEM_SPLITTER),
            accountName: assignee.name,
          }))}
        />
      ))}
    </Flex>
  );
};
